import { AppButton } from "@libs/zapi-ui/custom";

type TProps = {
  isPending: boolean;
  onClear: () => void;
};

export function PortfolioInvalidUrlState({ isPending, onClear }: TProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2">
      <p className="text-[14px] text-zinc-500 font-[400] text-center">
        Template is configured to an inaccessible server. <br /> Please clear the URL and try again.
      </p>
      <AppButton
        size="sm"
        appearance="outlined"
        onClick={onClear}
        disabled={isPending}
        className="flex items-center gap-2 text-red-600 border-red-200 hover:bg-red-50"
      >
        Clear
      </AppButton>
    </div>
  );
}
